<template>
  <ion-page class="signup-wrapper">
    <ion-content :fullscreen="true">
      <div class="logo-view">
        <ion-img class="logo-img" :src="require('@/assets/images/logo_multismall.png')"></ion-img>
      </div>
      <div class="container-login">
        <ion-item>
          <div class="label-view">
            <ion-icon :icon="mailOutline" slot="start"></ion-icon>
            <ion-label slot="end" class="label-style" position="stacked">
              Email
            </ion-label>
          </div>
          <ion-input
            :placeholder="'example@gmail.com'"
            v-model="state.email"
            autofocus
            class="ion-check-input"
          ></ion-input>
        </ion-item>
        <template v-if="v$.email.$error">
          <span
            class="error-message"
            v-for="(error, idx) in v$.email.$errors"
            :key="idx.toString()"
            style="color: red"
          >
            {{ error.$message }}
          </span>
        </template>
        <ion-item style="margin-top: 25px">
          <div class="label-view">
            <ion-icon :icon="lockClosedOutline" slot="start"></ion-icon>
            <ion-label class="label-style" position="stacked"> Username</ion-label>
          </div>
          <div class="input-view">
            <ion-input
              type="text"
              :placeholder="'@jane_doe'"
              v-model="state.profile.nickName"
              @ionBlur="formatNickname()"
              autofocus
            ></ion-input>
          </div>
        </ion-item>
        <template v-if="v$.profile.nickName.$error">
          <span
            class="error-message"
            v-for="(error, idx) in v$.profile.nickName.$errors"
            :key="idx.toString()"
          >
            {{ error.$message }}
          </span>
        </template>
        <ion-item style="margin-top: 25px">
          <div class="label-view">
            <ion-icon :icon="lockClosedOutline" slot="start"></ion-icon>
            <ion-label class="label-style" position="stacked"> Password</ion-label>
          </div>
          <div class="input-view">
            <ion-input
              :type="passwordType"
              :placeholder="'******'"
              v-model="state.password"
              autofocus
            ></ion-input>
            <ion-icon
              :icon="passwordIcon"
              @click="changePasswordType"
              color="black"
            ></ion-icon>
          </div>
        </ion-item>
        <template v-if="v$.password.$error">
          <span
            class="error-message"
            v-for="(error, idx) in v$.password.$errors"
            :key="idx.toString()"
          >
            {{ error.$message }}
          </span>
        </template>
        <ion-item style="margin-top: 25px">
          <div class="label-view">
            <ion-icon :icon="lockClosedOutline" slot="start"></ion-icon>
            <ion-label class="label-style" position="stacked">
              Confirm Password
            </ion-label>
          </div>
          <div class="input-view">
            <ion-input
              :type="confirmPasswordType"
              :placeholder="'Re-type your password '"
              v-model="state.confirmPassword"
              autofocus
            ></ion-input>
            <ion-icon
              :icon="confirmPasswordIcon"
              @click="changeConfirmPasswordType"
              color="black"
            ></ion-icon>
          </div>
        </ion-item>
        <template v-if="v$.confirmPassword.$error">
          <span
            class="error-message"
            v-for="(error, idx) in v$.confirmPassword.$errors"
            :key="idx.toString()"
          >
            {{ error.$message }}
          </span>
        </template>
        <ion-button class="login-btn" @click="signup()" :disabled="isLoading">
          <ion-label>
            <ion-spinner v-if="isLoading"></ion-spinner>
            <ion-text> Register</ion-text>
          </ion-label>
        </ion-button>
        <div style="padding-top: 20px; padding-bottom: 20px" class="dont-accrount">
          <span class="text-16-300">Already Have Account?</span>
          <a @click="() => router.push('/login')"> Login </a>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonContent,
  IonItem,
  IonPage,
  IonInput,
  IonLabel,
  IonImg,
  IonIcon,
  IonButton,
  IonSpinner,
  IonText,
toastController,
} from "@ionic/vue";
import { computed, defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import {
  mailOutline,
  closeCircle,
  lockClosedOutline,
  eyeOffOutline,
  eyeOutline,
} from "ionicons/icons";
import useValidate from "@vuelidate/core";
import { required, email, minLength, sameAs, helpers } from "@vuelidate/validators";
import { useUserStore } from "@/store/modules/user";
import { presentToastWithOptions } from "@/utils/functions";
import { TextFieldTypes } from "@ionic/core";
import { createUserWithEmailAndPassword, sendEmailVerification } from "@/helper/firebaseAuthLib";

export default defineComponent({
  name: "SignupPage",
  components: {
    IonContent,
    IonImg,
    IonPage,
    IonItem,
    IonInput,
    IonLabel,
    IonIcon,
    IonButton,
    IonSpinner,
    IonText,
  },
  setup() {
    const router = useRouter();
    const userStore = useUserStore();
    const isLoading = computed(() => userStore.isLoading);
    const passwordType = ref<TextFieldTypes>("password");
    const confirmPasswordType = ref<TextFieldTypes>("password");
    const passwordIcon = computed(() =>
      passwordType.value === "password" ? eyeOutline : eyeOffOutline
    );
    const confirmPasswordIcon = computed(() =>
      confirmPasswordType.value === "password" ? eyeOutline : eyeOffOutline
    );

    const state = reactive({
      email: "",
      password: "",
      confirmPassword: "",
      profile: {
        nickName: "",
      },
    });

    const checkEmail = async () => await userStore.emailExists(state.email);
    const checkEmailNick = async () =>
      await userStore.nicknameExists(state.profile.nickName);
    const checkString = () => {
      const regexr = /^@+[A-Za-z0-9_]*$/;
      const result = regexr.test(state.profile.nickName);
      return result;
    };
    const formatNickname = () =>{
      if(state.profile.nickName.length == 0){
       
        return
      }
      if( state.profile.nickName.substring(0,1) != '@' ) {
        state.profile.nickName = '@' + state.profile.nickName.toLocaleLowerCase()
      }
      state.profile.nickName = state.profile.nickName.toLocaleLowerCase()
    }
    const { withAsync, withMessage } = helpers;

   

    const rules = computed(() => {
      return {
        email: {
          required,
          email,
          asyncValidator: withMessage(
            "Email already exist. Please input other email.",
            withAsync(checkEmail)
          ),
        },
        password: { required, minLength: minLength(6) },
        confirmPassword: {
          sameAsPassword: withMessage("Password doesn't match", sameAs(state.password)),
        },
        profile: {
          nickName: {
            required,
            checkString: withMessage(
              `The first letter of the nickname must be "@" and use only characters, numbers and underscore`,
              withAsync(checkString)
            ),
            asyncValidator: withMessage(
              "Nickname already exist. Please input other nickname.",
              withAsync(checkEmailNick)
            ),
          },
        },
      };
    });

    const v$ = useValidate(rules, state);

    const changePasswordType = () =>
      (passwordType.value = passwordType.value === "password" ? "text" : "password");

    const changeConfirmPasswordType = () =>
      (confirmPasswordType.value =
        confirmPasswordType.value === "password" ? "text" : "password");

    // const signup = async () => {
    //   v$.value.$validate();
    //   if (!v$.value.$error) {
    //     const result = await userStore.axSignupUser(state);
    //     if (result) {
    //       presentToastWithOptions("Account Created", "success", "bottom");
    //       router.push("/login");
    //     } else presentToastWithOptions("Signup failed", "danger");
    //   }
    // };

    const signup = async () => {
      try {
        const user: any = await createUserWithEmailAndPassword(state.email, state.password);
        if (user?.code === 400) {
          const toast = await toastController.create({
            message: "Email already exists",
            color: "danger",
            duration: 3000,
          });
          toast.present();
        }
        console.log(user);
        await sendEmailVerification();
        userStore.axCreateOrFindFirebaseUser({...user, profile: state?.profile}, state.password);
        
        const toast = await toastController.create({
          message: "Check Your Email To Verify Address, then log into app",
          color: "danger",
          duration: 5000,
        });
        toast.present();
        router.push("/login");
      } catch (e) {
        // signupLoading.value = false;
        console.log(e);
      }
    };
    return {
      state,
      router,
      isLoading,
      passwordType,
      confirmPasswordType,
      v$,
      mailOutline,
      closeCircle,
      lockClosedOutline,
      eyeOffOutline,
      eyeOutline,
      passwordIcon,
      confirmPasswordIcon,
      signup,
      changePasswordType,
      changeConfirmPasswordType,
      formatNickname
    };
  },
});
</script>

<style scoped lang="scss">
@import "@/theme/variables/_color.scss";
@import "@/theme/variables/_typography.scss";

.signup-wrapper {
  ion-content {
    --background: radial-gradient(
      163.76% 50.49% at 61.92% 35.69%,
      rgba(225, 121, 203, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  ion-icon {
    color: $pink-normal;
  }

  ion-input {
    @include text-16-400;
  }

  ion-button {
    --background: #e383cf;
  }

  ion-label {
    ion-text {
      text-transform: capitalize;
    }
  }

  a {
    color: $pink-normal;
    @include text-16-400;
    border-bottom: 1px solid $pink-normal;
  }

  .label-style {
    @include text-18-bold;
    color: $pink-normal;
    margin-left: 8px;
    margin-bottom: 10px !important;
  }

  .forget-style {
    color: var(--ion-color-primary-contrast);
    font-size: 14px;
    font-weight: 400;
    text-align: right;
    margin-top: 8px;
  }

  .container-login {
    padding: 25px 25px 25px 25px;
    text-align: center;

    ion-item {
      border-bottom: 1px solid rgba(34, 34, 34, 0.25);
    }
  }

  .logo-view {
    height: 28%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
  }

  .logo-img {
    max-width: 337px;
    margin: auto;
  }

  .dont-accrount {
    margin: 35px 0 0 0;

    span {
      @include text-16-400;
      color: $black84;
    }
  }
}
</style>
<!--<style scoped>
ion-icon {
  color: var(&#45;&#45;ion-color-primary-contrast);
}

.label-style {
  &#45;&#45;color: var(&#45;&#45;ion-color-primary-contrast);
  font-size: 15px;
  font-weight: 400;
  margin-left: 8px;
  margin-bottom: 0 !important;
}

.forget-style {
  color: var(&#45;&#45;ion-color-primary-contrast);
  font-size: 14px;
  font-weight: 400;
  text-align: right;
  margin-top: 8px;
}

.container-login {
  background-image: linear-gradient(163.41deg, #e179cb -5.77%, #d7df4d 105.77%);
  flex: 1;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  position: absolute;
  min-height: calc(100vh - 30vh);
  top: 30%;
  left: 0;
  right: 0;
  padding: 10px 40px 50px 40px;
  text-align: center;
}

.logo-view {
  height: 28%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
}

.logo-img {
  width: 110px;
  margin: auto;
}

.dont-accrount {
  margin: 35 px 0 0 0;
}

ion-label {

  font-weight: 400;
  font-size: 16px !important;
}
</style>-->
